"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tools = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var react_redux_1 = require("react-redux");
var translate_1 = require("utils/translate");
var BriefcaseActions = require("@caddigital/sok-reducers/lib/actions/briefcase/list");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        list: state.briefcase.projectList,
        selectedLanguage: selectedLanguage
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchList: function (projectId) {
        return dispatch(BriefcaseActions.fetchRequest(projectId));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BriefcaseTools'), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        if (this.props.list.status === 'STANDBY') {
            this.props.fetchList(this.props.currentBriefcase.project);
        }
    }
}), recompose_1.pure);
exports.Tools = enhance(function (props) { return (React.createElement(sok_ui_1.ToolsSidebarWrap, { className: 'briefcase-view-tools-container' },
    React.createElement(sok_ui_1.ToolsSidebar, { className: 'briefcaseView-tools', headerIcon: React.createElement(sok_ui_1.Icon, { className: "fa-briefcase" }), headerText: (0, translation_1.getLocalization)('briefcaseView/briefcases') },
        React.createElement("div", { className: 'briefcase-list' },
            props.list.status === 'FETCHING' && (React.createElement("div", { className: 'message' },
                React.createElement(sok_ui_1.LoadingSpinner, null))),
            props.list.status === 'FAILED' && (React.createElement("div", { className: 'message' },
                React.createElement("div", null, (0, translation_1.getLocalization)('briefcaseView/errorFetcingBriefcases')))),
            props.list.status === 'FETCHED' &&
                props.list.list
                    .sort(function (a, b) { return a.name.localeCompare(b.name); })
                    .map(function (briefcase) { return (React.createElement("div", null,
                    React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, briefcase.name) },
                        React.createElement(sok_ui_1.ToolButton, { className: briefcase.id === props.currentBriefcase.id
                                ? 'selected'
                                : '', color: 'gray', type: 'list-item', text: briefcase.name, link: "/".concat(props.selectedLanguage, "/briefcase/").concat(briefcase.id), icon: React.createElement(sok_ui_1.Icon, { className: "fa-briefcase" }) })))); }))))); });
